var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefereeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4041 26.499C20.8071 26.499 26.8083 20.6792 26.8083 13.5C26.8083 6.32084 20.8071 0.500977 13.4041 0.500977C6.00124 0.500977 0 6.32084 0 13.5C0 20.6792 6.00124 26.499 13.4041 26.499Z",
    fill: "#328734"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7824 4.59945C11.0671 4.47119 8.45599 5.51477 6.79876 7.39009C6.65047 7.55722 6.57031 7.76905 6.57031 7.98864V20.051C6.57031 20.5601 6.99514 20.9721 7.52017 20.9721C8.04519 20.9721 8.47002 20.5601 8.47002 20.051V8.34428C9.75653 7.05195 11.6823 6.34263 13.6922 6.43786C15.5258 6.52336 17.2271 7.27544 18.3553 8.4978C19.2891 9.51028 19.76 10.7715 19.6779 12.0502C19.5817 13.5486 18.73 14.9536 17.3413 15.9039C16.9125 16.1973 16.8103 16.7706 17.1129 17.1865C17.4155 17.6024 18.0066 17.7015 18.4355 17.408C20.2971 16.1332 21.4393 14.2229 21.5716 12.1629C21.6838 10.3887 21.0446 8.65133 19.7681 7.26961C18.3012 5.6819 16.1209 4.70828 13.7824 4.59945Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.91,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0143 18.8075C17.5976 19.4313 15.9283 19.4138 14.5476 18.7569C13.4274 18.2264 12.6419 17.3558 12.3313 16.3083C12.0527 15.3619 12.207 14.3669 12.7641 13.5041C13.219 12.8006 13.9124 12.2351 14.744 11.8717L14.8001 14.503C14.8101 15.0043 15.2329 15.4047 15.7479 15.4047C15.754 15.4047 15.762 15.4047 15.768 15.4047C16.293 15.395 16.7078 14.9733 16.6978 14.466L16.5976 9.81173L11.8343 8.02969C11.3454 7.84701 10.7963 8.08216 10.6059 8.55633C10.4175 9.03051 10.66 9.56298 11.149 9.7476L13.2731 10.5424C12.4054 11.0438 11.672 11.722 11.151 12.5285C10.3053 13.8403 10.0749 15.3619 10.5037 16.8155C10.9546 18.3488 12.1249 19.6606 13.71 20.4127C14.6799 20.8732 15.752 21.1026 16.826 21.1026C17.842 21.1026 18.86 20.8966 19.7958 20.4846C20.2728 20.2747 20.4852 19.7286 20.2668 19.2661C20.0503 18.8036 19.4872 18.5976 19.0103 18.8094L19.0143 18.8075Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.91,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefereeLogo);
export default __webpack_public_path__ + "static/media/referee_logo.55eef84a9848cb040ad044e938772f1d.svg";
export { ForwardRef as ReactComponent };